export default {
  backLink: {
    display: 'flex',
    alignItems: 'center'
  },
  newToPobble: {
    margin: '0 5px 0 0'
  }
}
